import React from "react";
import nextId from "react-id-generator";
import { useHistory } from "react-router";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import {
  updateInstituteBasicDetails,
  uploadFile,
  uploadResume,
} from "../../../APIs/PostAPIS";
import { Images } from "../../../Assets/0a-exporter";
import CustomDropdown from "../../Common/CustomDropdown/CustomDropdown";
import Notification from "../../Portals/Notification/Notification";
import "./institution-details.style.scss";
import { MainContext } from "../../Dashboard/DashboardContext/Context";
import {
  getAllCities,
  getAllCountries,
  getAllStates,
} from "../../../APIs/GetAPIs";

const containerStyle = {
  width: "100%",
  height: "400px",
  marginBottom: "40px",
};

const center = {
  lat: 15.463,
  lng: 73.782,
};
const position = {
  lat: 15.463,
  lng: 73.782,
};

export default function InstitutionDetails({ changeRoute, currentRoute }) {
  const context = React.useContext(MainContext);
  const { initialChecking, userDetails } = context;
  const [error, setError] = React.useState(false);
  const [selectedPosition, setSelectedPosition] = React.useState(position);
  const [country, setCountry] = React.useState({ name: "", list: [] });
  const [state, setState] = React.useState({ name: "", list: [] });
  const [city, setCity] = React.useState({ name: "", list: [] });

  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });
  const [institutionDetails, setInstitutionDetails] = React.useState({
    institution_id: "",
    institution_website: "",
    institution_name: "",
    no_of_staff: "",
    institute_address: "",
    institute_location: {
      country: "",
      state: "",
      city: "",
      pin: "",
    },
    google_location: {
      lat: 0,
      lng: 0,
    },
    about_institution: "",
    institution_logo: "",
  });
  React.useEffect(() => {
    if (!userDetails) return;
    let temp = {
      institution_id: userDetails?.institution_id || "",
      institution_website: userDetails?.institution_website || "",
      institution_name: userDetails?.institution_name || "",
      no_of_staff: userDetails?.no_of_staff || "",
      institute_address: userDetails?.institute_address || "",
      institute_location: {
        country: userDetails?.institute_location?.country || "",
        state: userDetails?.institute_location?.state || "",
        city: userDetails?.institute_location?.city || "",
        pin: userDetails?.institute_location?.pin || "",
      },
      google_location: userDetails?.google_location || "",
      about_institution: userDetails?.about_institution || "",
      institution_logo: userDetails?.institution_logo || "",
    };
    if (userDetails?.institute_location?.country) {
      setCountry({
        ...country,
        name: userDetails?.institute_location?.country,
      });
    }
    setInstitutionDetails({ ...temp });
  }, [userDetails]);
  const handleUpload = async (e) => {
    setUploading(true);
    let doc = e.target.files[0];

    let ext = doc?.name?.toString()?.split(".");
    if (ext.length > 1) {
      let extension = ext[ext.length - 1];
      if (extension === "jpeg" || extension === "jpg" || extension === "png") {
      } else {
        setUploading(false);
        setNotification({
          status: true,
          title: "Please Select only JPEG or PNG file",
        });
        return;
      }
    } else {
      setUploading(false);
      setNotification({
        status: true,
        title: "Please Select only JPEG or PNG file",
      });
      return;
    }

    if (doc.size > 10000000) {
      setUploading(false);
      setNotification({
        status: true,
        title: "File must be less than 10MB",
      });
      return;
    }

    const formData = new FormData();
    formData.append("newFile", doc);
    try {
      let res = await uploadResume(formData);
      if (res.data.data) {
        setInstitutionDetails({
          ...institutionDetails,
          institution_logo: res.data.data.file_link,
        });
      } else {
      }

      setUploading(false);
    } catch (error) {
      setUploading(false);
    }
  };

  const clearNotification = () => {
    let a = setTimeout(() => {
      setNotification({
        status: false,
        title: "",
        moreDetails: "",
      });
      changeRoute();
      history.push("/register-institute/contact");
      setLoading(false);
      clearTimeout(a);
    }, [1000]);
  };
  const handleUpdate = async () => {
    try {
      setLoading(true);
      let res = await updateInstituteBasicDetails(institutionDetails);
      if (res.data.data) {
        initialChecking();
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: ``,
        });
        clearNotification();
      }

      setLoading(false);
    } catch (error) {}
  };

  const validations = () => {
    let check =
      !institutionDetails.institution_website ||
      !institutionDetails.no_of_staff ||
      !institutionDetails.institute_address ||
      !institutionDetails.institute_location.country ||
      !institutionDetails.institute_location.state ||
      !institutionDetails.institute_location.city ||
      !institutionDetails.institute_location.pin ||
      !institutionDetails.institution_logo ||
      !institutionDetails.about_institution;
    setError(check);
    return check;
  };
  const setUpCountries = async () => {
    try {
      let res = await getAllCountries();
      let tempList;
      if (res.data.data) {
        tempList = res.data.data.map((obj) => {
          return { ...obj, id: obj.isoCode };
        });
      }

      setCountry({
        ...country,
        name: userDetails?.institute_location?.country || "",
        list: [...tempList],
      });
    } catch (error) {}
  };

  const setUpStates = async () => {
    try {
      let res = await getAllStates(country.name);
      let tempList;
      if (res.data.data) {
        tempList = res.data.data.map((obj) => {
          return { ...obj, id: obj.isoCode };
        });
      }
      if (!state.name && userDetails?.institute_location?.state) {
        setState({
          name: userDetails?.institute_location?.state,
          list: [...tempList],
        });
      } else {
        setState({ name: "", list: [...tempList] });
      }
      setCity({ name: "", list: [] });
      setInstitutionDetails({
        ...institutionDetails,
        institute_location: {
          ...institutionDetails.institute_location,
          country: country.name,
          state: "",
          city: "",
        },
      });
    } catch (error) {
      console.error(error);
    }
  };
  const setUpCities = async () => {
    try {
      let res = await getAllCities(country.name, state.name);
      let tempList;
      if (res.data.data) {
        tempList = res.data.data.map((obj) => {
          return { ...obj, id: obj.name };
        });
      }

      if (!city.name && userDetails?.institute_location?.city) {
        setInstitutionDetails({
          ...institutionDetails,
          institute_location: {
            ...institutionDetails.institute_location,
            state: state.name,
            city: userDetails?.institute_location?.city,
          },
        });
        setCity({
          name: userDetails?.institute_location?.city,
          list: [...tempList],
        });
      } else {
        setInstitutionDetails({
          ...institutionDetails,
          institute_location: {
            ...institutionDetails.institute_location,
            state: state.name,
            city: "",
          },
        });
        setCity({ name: "", list: [...tempList] });
      }
    } catch (error) {
      console.error(error);
    }
  };
  const onLoad = (marker) => {};

  const handleOnClick = (coord) => {
    const { latLng } = coord;
    const lat = latLng.lat();
    const lng = latLng.lng();
    setSelectedPosition({
      lat: lat,
      lng: lng,
    });
    setInstitutionDetails({
      ...institutionDetails,
      google_location: {
        lat: lat,
        lng: lng,
      },
    });
  };

  React.useEffect(() => {
    if (!userDetails) return;
    setUpCountries();
  }, [userDetails]);
  React.useEffect(() => {
    if (!country.name) return;
    setUpStates();
  }, [country.name]);

  React.useEffect(() => {
    if (!state.name) return;
    setUpCities();
  }, [state.name]);
  return !userDetails ? (
    "Loading..."
  ) : (
    <div className="institution-details-main">
      <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
      <header className="idm-header">
        <h5>Step 1: Institute Details</h5>
      </header>
      <section className="idm-body">
        <div
          className={`fancy-input-wrapper ${
            error && !institutionDetails.institution_website ? "error" : ""
          }`}
        >
          <span>Official website*</span>
          <input
            name="institution_website"
            onChange={(e) =>
              setInstitutionDetails({
                ...institutionDetails,
                institution_website: e.target.value,
              })
            }
            value={institutionDetails.institution_website}
            placeholder=""
            required
          />
        </div>
        <div
          className={`fancy-input-wrapper ${
            error && !institutionDetails.institute_address ? "error" : ""
          }`}
        >
          <span>Institute Address*</span>
          <input
            name="institution_website"
            onChange={(e) =>
              setInstitutionDetails({
                ...institutionDetails,
                institute_address: e.target.value,
              })
            }
            value={institutionDetails.institute_address}
            placeholder=""
            required
          />
        </div>
        <CustomDropdown
          selected={institutionDetails?.no_of_staff}
          list={staffList}
          message="Select No of staff"
          title="No. of Staff*"
          error={error && !institutionDetails.no_of_staff}
          sendClicked={(obj) =>
            setInstitutionDetails({
              ...institutionDetails,
              no_of_staff: obj.id,
            })
          }
        />
        <CustomDropdown
          list={country.list}
          message="Select country"
          title="Country*"
          error={error && !institutionDetails.institute_location.country}
          selected={institutionDetails.institute_location.country}
          sendClicked={(obj) => {
            setInstitutionDetails({
              ...institutionDetails,
              institute_location: {
                ...institutionDetails.institute_location,
                country: obj.id,
              },
            });
            setCountry({ ...country, name: obj.id });
          }}
        />
        <CustomDropdown
          error={error && !institutionDetails.institute_location.state}
          sendClicked={(obj) => {
            setInstitutionDetails({
              ...institutionDetails,
              institute_location: {
                ...institutionDetails.institute_location,
                state: obj.id,
              },
            });
            setState({ ...state, name: obj.id });
          }}
          list={state.list}
          message="Select state"
          title="State*"
          selected={institutionDetails.institute_location.state}
        />
        <CustomDropdown
          error={error && !institutionDetails.institute_location.city}
          sendClicked={(obj) => {
            setInstitutionDetails({
              ...institutionDetails,
              institute_location: {
                ...institutionDetails.institute_location,
                city: obj.id,
              },
            });
            setCity({ ...city, name: obj.id });
          }}
          list={city.list}
          message="Select city"
          title="City*"
          selected={institutionDetails.institute_location.city}
        />
        <div
          className={`fancy-input-wrapper ${
            error && !institutionDetails.institute_location.pin ? "error" : ""
          }`}
        >
          <span>Pin Code*</span>
          <input
            type="number"
            value={institutionDetails.institute_location.pin}
            onChange={(e) =>
              setInstitutionDetails({
                ...institutionDetails,
                institute_location: {
                  ...institutionDetails.institute_location,
                  pin: e.target.value,
                },
              })
            }
            placeholder="Enter pin"
            required
          />
        </div>
        <div
          className={`fancy-input-wrapper ${
            error && !institutionDetails.google_location ? "error" : ""
          }`}
        >
          <span>Google Map Location</span>
          <div className="lat-and-lang">
            <h6>
              Latitude: <p>{parseFloat(selectedPosition.lat).toFixed(8)}</p>
            </h6>
            <h6>
              Longitude: <p>{parseFloat(selectedPosition.lat).toFixed(8)}</p>
            </h6>
          </div>
        </div>

        <LoadScript googleMapsApiKey={process.env.REACT_APP_API_KEY}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={selectedPosition}
            zoom={8}
            onClick={handleOnClick}
          >
            <Marker onLoad={onLoad} position={selectedPosition} />
          </GoogleMap>
        </LoadScript>

        <div
          className={`fancy-input-wrapper ${
            error && !institutionDetails.about_institution ? "error" : ""
          }`}
        >
          <span>About Institute*</span>
          <textarea
            rows="6"
            style={{ height: "auto" }}
            cols={10}
            onChange={(e) =>
              setInstitutionDetails({
                ...institutionDetails,
                about_institution: e.target.value,
              })
            }
            value={institutionDetails.about_institution}
            placeholder=""
            required
          />
        </div>

        <div className="urm-body">
          <div className="urm-info">
            <h6>Upload institute logo*</h6>
            <p>Logo (Only PNG, JPG formats. Max size upto 10 MB)</p>
          </div>
          <label
            htmlFor="logo"
            className={`drop-and-zone-area ${
              error && !institutionDetails.institution_logo ? "error-zone" : ""
            }`}
          >
            <input
              onChange={(e) => {
                handleUpload(e);
                e.target.value = "";
              }}
              accept="image/*"
              className="d-none"
              type="file"
              id="logo"
            />
            <img
              src={
                !institutionDetails.institution_logo
                  ? Images.uploadLogo
                  : institutionDetails.institution_logo
              }
            />
            <div>
              {uploading ? (
                <h6>Uploading....</h6>
              ) : institutionDetails.institution_logo ? (
                ""
              ) : (
                <>
                  <h6>Drag & Drop here or browse files</h6>
                  <p>Logo (Only PNG, JPG formats. Max size upto 10 MB)</p>
                </>
              )}
            </div>
          </label>
        </div>
        <div className="idm-footer">
          <button
            onClick={() => (validations() ? console.log() : handleUpdate())}
            type="submit"
          >
            {loading ? "Updating..." : "Update"}
          </button>
        </div>
      </section>
    </div>
  );
}
const countryList = [
  { _id: nextId(), name: "India", id: "ind" },
  { _id: nextId(), name: "Sri Lanka", id: "sl" },
  { _id: nextId(), name: "England", id: "eng" },
  { _id: nextId(), name: "Australia", id: "aus" },
];
const stateList = [
  { _id: nextId(), name: "Karnataka", id: "ka" },
  { _id: nextId(), name: "gujrat", id: "guj" },
  { _id: nextId(), name: "Goa", id: "ga" },
  { _id: nextId(), name: "Assam", id: "assam" },
];
const cityList = [
  { _id: nextId(), name: "Bangalore", id: "bangalore" },
  { _id: nextId(), name: "Mumbai", id: "mumbai" },
  { _id: nextId(), name: "Pune", id: "pune" },
  { _id: nextId(), name: "Delhi", id: "delhi" },
];
const staffList = [
  { _id: nextId(), name: "1 - 50", id: "1_50" },
  { _id: nextId(), name: "50 - 100", id: "50_100" },
  { _id: nextId(), name: "100 - 200", id: "100_200" },
  { _id: nextId(), name: "200 +", id: "200+" },
];
